<template>
  <div>
    <div class="flex-row padding">
      <span class="check-btn" :class="{ activeStyle: active === 'A' }" @click="selected('A')">正确</span>
      <span class="check-btn" :class="{ activeStyle: active === 'B' }" @click="selected('B')">错误</span>
    </div>
    <answer :test="test" v-if="showAnswer"></answer>
  </div>
</template>

<script>
import answer from './answer.vue'
export default {
  components: {
    answer,
  },
  name: 'check-test',
  props: {
    test: {
      type: Object,
      default: () => ({})
    },
    testId: {
      type: Number,
      default: () => null,
    },
    choiceAnswer: {
      type: String,
      default: () => '',
    },
    tempResult: {
      type: String,
      default: () => '',
    },
    showAnswer: { // 是否显示答案
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      active: '',
    };
  },

  mounted() {
    this.setWatch();
  },

  methods: {
    selected(item) {
      this.active = item;
      const value = {
        result: item, // 直接保存 A/B，而不是中文，方便统一处理
        isRight: this.test.answer === item,
        content: item === 'A' ? '正确' : '错误',
      };

      this.$emit('selectChange', item);
      this.$emit('change', value);
    },
    setWatch() {
      const answer = this.tempResult || this.choiceAnswer;
      if (answer) {
        this.active = answer;
        if (this.active === '正确' || this.active === 'A') {
          this.active = 'A';
        }
        if (this.active === '错误' || this.active === 'B') {
          this.active = 'B';
        }
      }
    }
  },
  watch: {
    tempResult(newValue) {
      if (newValue) {
        this.setWatch();
      }
    },
    choiceAnswer() {
      this.setWatch();
    },
    testId() {
      this.active = '';
      this.setWatch();
    }
  }
}
</script>

<style scoped>
.padding {
  padding: 0 24rpx;
}

.check-btn {
  width: 26%;
  height: 50px;
  line-height: 50px;
  text-align: center;
  border-radius: 15px;
  border: 1px solid #e4e4e4;
  font-size: 16px;
  color: #333;
}

.activeStyle {
  border: 1px solid #fff;
  background: #007AFF;
  color: #ffffff;
}
</style>
